import React, { useState } from "react";
import { Link, NavLink } from "react-router-dom";
import "../App.css";
import "./TechPrimersContent.css";
import Container from "@material-ui/core/Container";
import FoundationNavBar from "./FoundationNavBar";
// import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';

function TechPrimersContent() {
  return (
    <div className="main-container foundation-tech-container" id="main">
      <title>Foundation - Technology Foundational Primers</title>
      <h1 class="sr-only" tabIndex={0}>
        Foundation - Technology Foundational Primers
      </h1>
      <img
        src="/images/Foundation/foundation.png"
        alt="foundation-banner-image"
        className="banner-img"
      />
      <FoundationNavBar />
      <div className="foundation-phase">
        <p>
          Technology primers cater to the foundational upskilling in technology
          specific areas.
        </p>
      </div>
      <div className="system-eng-container">
        <h2>System Engineering</h2>
        <div className="sys-eng-new-wrap">
          <div className="sys-eng-new-row">
            <div className="sys-eng-new-box">
              <h3>App Dev</h3>
              <div className="ess-wrap">
                <span className="plus-symbol">+</span>
                <div className="ess-row">
                  <div className="ess-box box1">
                    <h4>Essentials</h4>
                    <div className="arrow-down"></div>
                    <div className="lists-box">
                      <ul>
                        <li>
                          <img
                            src="images/Foundation/arrow-bullet-new.png"
                            alt="arrow"
                            className="arrow-bullet"
                          />{" "}
                          Software Fundamentals
                        </li>
                        <li>
                          <img
                            src="images/Foundation/arrow-bullet-new.png"
                            alt="arrow"
                            className="arrow-bullet"
                          />{" "}
                          Web Technologies
                        </li>
                        <li>
                          <img
                            src="images/Foundation/arrow-bullet-new.png"
                            alt="arrow"
                            className="arrow-bullet"
                          />{" "}
                          Generative AI
                        </li>
                        <li>
                          <img
                            src="images/Foundation/arrow-bullet-new.png"
                            alt="arrow"
                            className="arrow-bullet"
                          />{" "}
                          Agile and DevOps
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
                <div className="ess-row">
                  <div className="ess-box box2">
                    <h4>Electives</h4>
                    <div className="arrow-down"></div>
                    <div className="lists-box">
                      <ul>
                        <li>
                          <img
                            src="images/Foundation/arrow-bullet-new.png"
                            alt="arrow"
                            className="arrow-bullet"
                          />{" "}
                          Programming: Python/ Java/.NET
                        </li>
                        <li>
                          <img
                            src="images/Foundation/arrow-bullet-new.png"
                            alt="arrow"
                            className="arrow-bullet"
                          />{" "}
                          Database : MongoDB/ Oracle/ MySQL
                        </li>
                        <li>
                          <img
                            src="images/Foundation/arrow-bullet-new.png"
                            alt="arrow"
                            className="arrow-bullet"
                          />{" "}
                          Cloud : AWS/ Azure/ GCP
                        </li>
                      </ul>
                      <p>**Pick one area from each of the topic choices</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="sys-eng-new-row">
            <div className="sys-eng-new-box">
              <h3>Security</h3>
              <div className="ess-wrap">
                <span className="plus-symbol">+</span>
                <div className="ess-row">
                  <div className="ess-box box1">
                    <h4>Essentials</h4>
                    <div className="arrow-down"></div>
                    <div className="lists-box">
                      <ul>
                        <li>
                          <img
                            src="images/Foundation/arrow-bullet-new.png"
                            alt="arrow"
                            className="arrow-bullet"
                          />{" "}
                          Security & Cybersecurity fundamentals
                        </li>
                        <li>
                          <img
                            src="images/Foundation/arrow-bullet-new.png"
                            alt="arrow"
                            className="arrow-bullet"
                          />{" "}
                          Windows Server 2016 & Linux Administration
                        </li>
                        <li>
                          <img
                            src="images/Foundation/arrow-bullet-new.png"
                            alt="arrow"
                            className="arrow-bullet"
                          />{" "}
                          Application Security Fundamentals & Digital Identity
                        </li>
                        <li>
                          <img
                            src="images/Foundation/arrow-bullet-new.png"
                            alt="arrow"
                            className="arrow-bullet"
                          />{" "}
                          Infrastructure & Security Overview & Network
                          Fundamentals
                        </li>
                        <li>
                          <img
                            src="images/Foundation/arrow-bullet-new.png"
                            alt="arrow"
                            className="arrow-bullet"
                          />{" "}
                          ITIL 4 Foundation & SIEM Fundamentals
                        </li>
                        <li>
                          <img
                            src="images/Foundation/arrow-bullet-new.png"
                            alt="arrow"
                            className="arrow-bullet"
                          />{" "}
                          Cloud & Cloud Security Fundamentals
                        </li>
                        <li>
                          <img
                            src="images/Foundation/arrow-bullet-new.png"
                            alt="arrow"
                            className="arrow-bullet"
                          />{" "}
                          Agile/Sec DevOps
                        </li>
                        <li>
                          <img
                            src="images/Foundation/arrow-bullet-new.png"
                            alt="arrow"
                            className="arrow-bullet"
                          />{" "}
                          Generative AI
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
                <div className="ess-row">
                  <div className="ess-box box2">
                    <h4>Electives</h4>
                    <div className="arrow-down"></div>
                    <div className="lists-box">
                      <ul>
                        <li>
                          <img
                            src="images/Foundation/arrow-bullet-new.png"
                            alt="arrow"
                            className="arrow-bullet"
                          />{" "}
                          Programming: Python/ Java/ PowerShell
                        </li>
                        <li>
                          <img
                            src="images/Foundation/arrow-bullet-new.png"
                            alt="arrow"
                            className="arrow-bullet"
                          />{" "}
                          Database: Oracle/ MySQL/ MongoDB
                        </li>
                        <li>
                          <img
                            src="images/Foundation/arrow-bullet-new.png"
                            alt="arrow"
                            className="arrow-bullet"
                          />{" "}
                          Cloud: AWS/ Azure/ GCP
                        </li>
                      </ul>
                      <p>**Pick one area from each of the topic choices</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="snow-wrap">
          <div className="snow-row">
            <div className="snow-box">
              <h3>SNOW</h3>
              <ul>
                <li>
                  <img
                    src="images/Foundation/arrow-bullet-new.png"
                    alt="arrow"
                    className="arrow-bullet"
                  />{" "}
                  ITIL 4 Foundation
                </li>
                <li>
                  <img
                    src="images/Foundation/arrow-bullet-new.png"
                    alt="arrow"
                    className="arrow-bullet"
                  />{" "}
                  JavaScript
                </li>
                <li>
                  <img
                    src="images/Foundation/arrow-bullet-new.png"
                    alt="arrow"
                    className="arrow-bullet"
                  />{" "}
                  HTML
                </li>
                <li>
                  <img
                    src="images/Foundation/arrow-bullet-new.png"
                    alt="arrow"
                    className="arrow-bullet"
                  />{" "}
                  CSS and JQuery
                </li>
                <li>
                  <img
                    src="images/Foundation/arrow-bullet-new.png"
                    alt="arrow"
                    className="arrow-bullet"
                  />{" "}
                  Service Now{" "}
                </li>
              </ul>
            </div>
          </div>
        </div>
        {/* <div className="system-eng-wrap wrap1">
          <div className="system-eng-row">
            <div className="system-eng-box">
              <h3>App Dev, Cloud App Engineering, Data Engineering</h3>
              <ul>
                <li>Logic Development</li>
                <li>Software Engineering</li>
                <li>Java Programming</li>
                <li>RDBMS and SQL</li>
                <li>Agile Fundamentals</li>
                <li>Introduction to DevOps and Tools</li>
              </ul>
              <p>90 Hours</p>
            </div>
          </div>
          <div className="system-eng-row">
            <div className="system-eng-box">
              <h3>Security</h3>
              <ul>
                <li>Infrastructure & Security Overview</li>
                <li>Security Fundamentals</li>
                <li>Cybersecurity Fundamentals</li>
                <li>Windows Server 2016</li>
                <li>Linux Basics</li>
                <li>Cloud & Cloud Security Fundamentals</li>
                <li>Network Fundamentals & Security</li>
                <li>Digital Identity Fundamentals</li>
                <li>SIEM Fundamentals</li>
                <li>Application Security Fundamentals</li>
                <li>ITIL 4 Foundation</li>
              </ul>
              <p>90 Hours</p>
            </div>
          </div>
          <div className="system-eng-row">
            <div className="system-eng-box">
              <h3>Service Now</h3>
              <ul>
                <li>ITIL 4 Foundation</li>
                <li>JavaScript</li>
                <li>HTML</li>
                <li>CSS and JQuery</li>
                <li>Service Now</li>
              </ul>
              <p>90 Hours</p>
            </div>
          </div>
        </div> */}
        {/* <div className="enhanced-wrap">
          <div className="enhanced-row">
            <div className="enhanced-box">
              <span className="plus-symb">+</span>
              <h3 className="enhanced">Enhanced C2C</h3>
            </div>
          </div>
        </div> */}
        <h2>System and Application Services</h2>
        <div className="sys-eng-new-wrap">
          <div className="sys-eng-new-row">
            <div className="sys-eng-new-box">
              <h3>App Dev Prep</h3>
              <div className="ess-wrap">
                <span className="plus-symbol">+</span>
                <div className="ess-row">
                  <div className="ess-box box1">
                    <h4>Essentials</h4>
                    <div className="arrow-down"></div>
                    <div className="lists-box">
                      <ul>
                        <li>
                          <img
                            src="images/Foundation/arrow-bullet-new.png"
                            alt="arrow"
                            className="arrow-bullet"
                          />{" "}
                          Software Fundamentals
                        </li>
                        <li>
                          <img
                            src="images/Foundation/arrow-bullet-new.png"
                            alt="arrow"
                            className="arrow-bullet"
                          />{" "}
                          Web Technologies
                        </li>
                        <li>
                          <img
                            src="images/Foundation/arrow-bullet-new.png"
                            alt="arrow"
                            className="arrow-bullet"
                          />{" "}
                          Generative AI
                        </li>
                        <li>
                          <img
                            src="images/Foundation/arrow-bullet-new.png"
                            alt="arrow"
                            className="arrow-bullet"
                          />{" "}
                          Agile and DevOps
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
                <div className="ess-row">
                  <div className="ess-box box2">
                    <h4>Electives</h4>
                    <div className="arrow-down"></div>
                    <div className="lists-box">
                      <ul>
                        <li>
                          <img
                            src="images/Foundation/arrow-bullet-new.png"
                            alt="arrow"
                            className="arrow-bullet"
                          />{" "}
                          Programming: Python/ Java/.NET
                        </li>
                        <li>
                          <img
                            src="images/Foundation/arrow-bullet-new.png"
                            alt="arrow"
                            className="arrow-bullet"
                          />{" "}
                          Database : MongoDB/ Oracle/ MySQL
                        </li>
                        <li>
                          <img
                            src="images/Foundation/arrow-bullet-new.png"
                            alt="arrow"
                            className="arrow-bullet"
                          />{" "}
                          Cloud : AWS/ Azure/ GCP
                        </li>
                      </ul>
                      <p>**Pick one area from each of the topic choices</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="sys-eng-new-row">
            <div className="sys-eng-new-box">
              <h3>Infrastructure Engineering (IE)</h3>
              <div className="ess-wrap">
                <span className="plus-symbol">+</span>
                <div className="ess-row">
                  <div className="ess-box box1">
                    <h4>Essentials</h4>
                    <div className="arrow-down"></div>
                    <div className="lists-box">
                      <ul>
                        <li>
                          <img
                            src="images/Foundation/arrow-bullet-new.png"
                            alt="arrow"
                            className="arrow-bullet"
                          />{" "}
                          Infrastructure Overview
                        </li>
                        <li>
                          <img
                            src="images/Foundation/arrow-bullet-new.png"
                            alt="arrow"
                            className="arrow-bullet"
                          />{" "}
                          ITIL 4 Foundation
                        </li>
                        <li>
                          <img
                            src="images/Foundation/arrow-bullet-new.png"
                            alt="arrow"
                            className="arrow-bullet"
                          />{" "}
                          Security Concepts
                        </li>
                        <li>
                          <img
                            src="images/Foundation/arrow-bullet-new.png"
                            alt="arrow"
                            className="arrow-bullet"
                          />{" "}
                          DevOps Overview
                        </li>
                        <li>
                          <img
                            src="images/Foundation/arrow-bullet-new.png"
                            alt="arrow"
                            className="arrow-bullet"
                          />{" "}
                          Linux
                        </li>
                        <li>
                          <img
                            src="images/Foundation/arrow-bullet-new.png"
                            alt="arrow"
                            className="arrow-bullet"
                          />{" "}
                          Generative AI
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
                <div className="ess-row">
                  <div className="ess-box box2">
                    <h4>Electives</h4>
                    <div className="arrow-down"></div>
                    <div className="lists-box">
                      <ul>
                        <li>
                          <img
                            src="images/Foundation/arrow-bullet-new.png"
                            alt="arrow"
                            className="arrow-bullet"
                          />{" "}
                          Operating System - Windows or Linux
                        </li>
                      </ul>
                      <p>**Pick one area from the topic choice</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* <div className="system-eng-wrap wrap2">
          <div className="system-eng-row">
            <div className="system-eng-box">
              <h3>Low Code/No Code, Test Engineering</h3>
              <ul>
                <li>Logic Development</li>
                <li>Software Engineering</li>
                <li>Java Programming</li>
                <li>RDBMS and SQL</li>
                <li>Agile Fundamentals</li>
                <li>Introduction to DevOps and Tools</li>
              </ul>
              <p>90 Hours</p>
            </div>
          </div>
          <div className="system-eng-row">
            <div className="system-eng-box">
              <h3>App Dev Prep</h3>
              <ul>
                <li>Logic Development and SE</li>
                <li>OOPS and UML</li>
                <li>Algorithm Analysis and Design Concepts</li>
                <li>Programming using Java</li>
                <li>RDBMS cocepts & SQL using Oracle</li>
                <li>HTML,CSS,JS and jQuery</li>
              </ul>
              <p>135 Hours</p>
            </div>
          </div>
          <div className="system-eng-row">
            <div className="system-eng-box">
              <h3>Infra Support</h3>
              <ul>
                <li>Infrastructure Overview</li>
                <li>ITIL 4 Foundation</li>
                <li>Windows 10</li>
                <li>Windows Server 2016</li>
                <li>Linux</li>
                <li>Network Fundamentals</li>
                <li>Security Concepts</li>
                <li>AWS Practitioner</li>
                <li>Azure Fundamentals</li>
                <li>RDBMS</li>
                <li>DevOps Overview</li>
              </ul>
              <p>90 Hours</p>
            </div>
          </div>
          <div className="system-eng-row">
            <div className="system-eng-box">
              <h3>PCS</h3>
              <ul>
                <li>PCS Fundamentals</li>
                <li>PMO Introduction</li>
                <li>MS Office</li>
                <li>Intelligent Automation</li>
              </ul>
              <p>45 Hours</p>
            </div>
          </div>
        </div> */}
        {/* <div className="enhanced-wrap">
          <div className="enhanced-row">
            <div className="enhanced-box">
              <span className="plus-symb">+</span>
              <h3 className="enhanced">Enhanced C2C</h3>
            </div>
          </div>
        </div> */}
        {/* <h3 className="track-familly">
          <span className="career"></span> Career Track |{" "}
          <span className="job"></span> Job Family
        </h3> */}
      </div>
    </div>
  );
}

export default TechPrimersContent;
